
export interface GetContainerListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetContainerListPagingAndFilterResponseData
}

export interface GetContainerListPagingAndFilterResponseData {
    items: GetContainerListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetContainerListPagingAndFilterResponseItem {
    containerId: string
    companyId: string | undefined
    code: string
    name: string
    width: number
    length: number
    height: number
    volume: number
    doorWidth: number
    doorHeight: number
    emptyWeight: number
    maxLoadWeight: number
    ceilingHeight: number
    standartPalletCapacity: number
    euroPalletCapacity: number
    image: string
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export const initialGetContainerListPagingAndFilterResponseData: GetContainerListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}